import { useEffect } from "react";

export function Close() {
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const mmbToken = urlParams.get("mmb_token");
        if (mmbToken) {
            window.postMessage({
                origin: "WEBPAGE",
                content: {
                  type: "SET_API_KEY",
                  apiKey: mmbToken
                }
            }, "*");
        }
        setTimeout(() => {
            window.close();
        }, 5000);
    }, []);
    return <div style={{ padding: "2rem", textAlign: "center" }}>
        <h2>Extension Activated ✅</h2>
        <p>You are now logged into the makemybrand extension.</p>
        <p>You can close this tab.</p>
    </div>;
}
